import { api } from "@/shared/libs/axiosClient";
import type {
    GetOffboardingInfoResponse,
    StartOffboardingRequest,
} from "../types/offboarding-types";

/**
 * 오프보딩에 필요한 정보 조회
 * @returns 오프보딩 가능한 조직 목록
 */
export async function getOffboardingInfo(): Promise<GetOffboardingInfoResponse> {
    return api.get<GetOffboardingInfoResponse>("/organizations/offboarding/info");
}

/**
 * 조직 오프보딩 시작
 */
export async function startOffboarding(request: StartOffboardingRequest): Promise<void> {
    return api.post("/organizations/offboarding/start", request);
}
